import { storeCache } from 'shared/store/StoreCache'
import { bannerStore } from 'shared/ui'
import { logger } from 'shared/lib'
import { IS_APP_LIGHT, IS_CALLING_APP_LIGHT } from 'shared/config'
import { clearSessionIntercom } from 'entities/Intercom'
import { AuthApi } from 'entities/Auth/api'
import { getAssumeToken, removeToken } from 'entities/Auth/lib/setToken'
import { AuthPath } from 'pages/auth/route/authPath'
import { RegisterPath } from 'pages/register/route/registerPath'

export const logout = async () => {
  const isAssume = Boolean(getAssumeToken())

  storeCache.dispose()
  clearSessionIntercom()

  if (isAssume) {
    window.close()
    return
  }

  try {
    localStorage.removeItem('showedAwayStatusDate')
    localStorage.removeItem('contactDetailsOpenStatus')

    await AuthApi.logout()
  } catch (e) {
    logger.error(e)
  } finally {
    removeToken()
    bannerStore.dispose()
    window.userpilot?.destroy?.()
    if (
      window.location.href.includes(AuthPath.login) ||
      window.location.pathname === `/${RegisterPath.root}`
    ) {
      return
    }

    if (IS_APP_LIGHT || IS_CALLING_APP_LIGHT) {
      window.location.reload()
      return
    }

    window.stop()
    window.location.href = `/${AuthPath.login}`
  }
}
